import { useState } from 'react';
import tokenPlaceholder from '@/assets/token-placeholder.png';

interface TokenLogoProps {
  symbol: string;
  logoUrl: string | undefined;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-9 h-9',
};

export function TokenLogo({
  symbol,
  logoUrl,
  size = 'md',
  className = '',
}: TokenLogoProps) {
  const [imageError, setImageError] = useState(false);

  // Show placeholder if no logoUrl or image failed to load
  if (!logoUrl || imageError) {
    return (
      <img
        src={tokenPlaceholder}
        alt={`${symbol} placeholder`}
        className={`${sizeClasses[size]} rounded-full object-contain ${className}`}
      />
    );
  }

  // Show original image
  return (
    <img
      src={logoUrl}
      alt={`${symbol} logo`}
      className={`${sizeClasses[size]} rounded-full object-contain ${className}`}
      onError={() => setImageError(true)}
    />
  );
}
